module.exports = __webpack_public_path__ + "img/folder.2e23d600.svg";